import script from "./sidepane-communication-empty-slim.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidepane-communication-empty-slim.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__